// extracted by mini-css-extract-plugin
export default {"section__draw":"BgLine2--section__draw--mJp8I"};